export default {
  Helptext1:
    "Varios términos de búsqueda pueden separarse por espacios (El resultado de la búsqueda contendrá la cadena).",
  Helptext2:
    "Las comillas dobles '...' buscarán una cadena exacta (en algunos casos esto podría acelerar la búsqueda).",
  Helptext3: "También es posible buscar múltiples cadenas exactas '...' '...' '...'.",
  globalErrorMessageHeader: "Error",
  globalErrorMessage:
    "Ha ocurrido un error durante su solicitud y se ha informado al soporte de TI. Resolveremos este problema lo antes posible y lamentamos las molestias.",
  SelectOrCreateAttribute1: "Seleccione o",
  SelectOrCreateAttribute2: "un atributo para definir sus parámetros",
  createNewAttributeSets1: "Aún no se han creado conjuntos de atributos. Haga clic en ",
  createNewAttributeSets2: " ,para crearlos.",
  click: "clic",
  toCreate: ", para crearlo!",
  selectAttributeToChangeParameters: "Seleccione un atributo para cambiar sus parámetros",
  resetPassword: "Será redirigido a un sitio web externo para restablecer su contraseña. ¿Desea continuar?",
  noPicturesUploaded: "No se han subido imágenes",
};
